/*
    All the products belonging to the subcategories listed in the following array
    will display a control in the product page with which the user could select the cut type before adding it to the cart
*/
export default ['0303']
